export default function StructureSection() {
  const steps = [
    {
      icon: "ri-user-line",
      title: "Investor",
      desc: "Certified High Net Worth Individual, Sophisticated Investor, or eligible retail investor.",
      direction: "right",
    },
    {
      icon: "ri-building-4-line",
      title: "Special Purpose Vehicle (SPV)",
      desc: "Investor capital is deployed into a ring-fenced SPV established solely for acquiring the underlying assets.",
      direction: "right",
    },
    {
      icon: "ri-home-2-line",
      title: "UK Assisted Living Properties",
      desc: "The SPV acquires UK assisted living properties, held with first legal charges as security for investors.",
      direction: "right",
    },
    {
      icon: "ri-community-line",
      title: "Housing Association",
      desc: "Properties are leased to a UK-registered housing association under long-term agreements (up to 25 years), with no void periods.",
      direction: "right",
    },
    {
      icon: "ri-coins-line",
      title: "Rental Income",
      desc: "Index-linked rental income (CPI + 1%) flows through the structure. Returns are distributed monthly to investors.",
      direction: null,
    },
  ];

  const haFeatures = [
    "Index-linked rent increases (CPI + 1%)",
    "Assured rental income — no void periods",
    "Full Repair & Insurance (FRI) lease structure",
    "Housing association responsible for all maintenance",
    "Long-term agreements of up to 25 years",
  ];

  return (
    <section className="bg-[#EEF2F9] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Structure Flow */}
        <div className="text-center mb-14">
          <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-3">
            Investment Architecture
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#071A2E]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Structure Overview
          </h2>
          <p className="text-slate-500 text-sm mt-3 max-w-lg mx-auto">
            Investor capital flows through a structured arrangement designed to deliver consistent monthly income whilst maintaining asset-backed security.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-0 mb-16 overflow-x-auto">
          {steps.map((s, i) => (
            <div key={s.title} className="flex flex-col lg:flex-row items-center">
              <div className="flex flex-col items-center text-center w-44">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#071A2E] text-[#C9A84C] mb-3 flex-shrink-0">
                  <i className={`${s.icon} text-xl leading-none`} />
                </div>
                <p className="font-bold text-[#071A2E] text-xs mb-1">{s.title}</p>
                <p className="text-slate-500 text-xs leading-relaxed">{s.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="flex items-center justify-center w-10 h-10 flex-shrink-0 rotate-90 lg:rotate-0">
                  <i className="ri-arrow-right-line text-[#C9A84C] text-xl leading-none" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Housing Association Agreement */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="w-full h-80 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=two%20British%20property%20investment%20professionals%20reviewing%20architectural%20blueprints%20and%20property%20documents%20spread%20on%20a%20table%20in%20a%20modern%20UK%20office%2C%20warm%20natural%20light%20from%20window%2C%20focused%20discussion%20over%20real%20estate%20plans%2C%20editorial%20candid%20style%2C%20investment%20deal%2C%20property%20acquisition%20meeting%2C%20no%20faces%20fully%20visible%2C%20authentic%20business%20setting%2C%20shallow%20depth%20of%20field&width=700&height=380&seq=810&orientation=landscape"
              alt="Housing association agreement"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-3">
              Lease Agreement
            </span>
            <h3
              className="text-2xl font-bold text-[#071A2E] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Housing Association Agreement
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed mb-6">
              All properties are leased to a UK-registered housing association under long-term agreements. This structure ensures assured rental income flows through to service investor distributions throughout the investment term.
            </p>
            <div className="flex flex-col gap-3">
              {haFeatures.map((f) => (
                <div key={f} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-green-100 flex-shrink-0">
                    <i className="ri-check-line text-green-600 text-xs leading-none" />
                  </div>
                  <span className="text-sm text-[#071A2E]">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
